<template>
  <v-dialog v-model="dialog"
            @click:outside="closeDialog"
            max-width="1600px"
            scrollable
  >
    <v-card>
      <v-card-text class="p-0" style="padding:0; display:flex; justify-content: center;">
        <GmapMap
          ref="map"
          :center="mapCenter"
          :zoom="mapZoom"
          :tilt="45"
          :map-type-id="mapType"
          :options="mapOptions"
          id="searchPropertiesMap"
          style="width: 100%;  height:90vh;"
          @click="onMapClick"
        >
        <!-- <GmapRectangle
            ref="rectangle"
            :bounds="rectangleBounds"
            :editable="true"
            :draggable="true"
            @bounds_changed="onBoundsChanged"
          /> -->
          <GmapMarker v-for="propertyAddress in addresses"
                      :position="{lat: propertyAddress.lat, lng: propertyAddress.lng}"
                      :title="propertyAddress.unit"
                      :icon="markerOptions"
                      :key="propertyAddress.id + '_marker'"
                      :size="markerOptions.scaledSize"
                      style="z-index: 5;"
          />

          <!-- button to submit selection -->
          

        </GmapMap>

        <!-- close button with x icon top right -->
        <v-btn
          icon
          @click="closeDialog"
          dark
          style="position: absolute; top: 10px; right: 10px; z-index: 500; "
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-btn
          color="primary"
          dark
          @click="submitSelection"
          style="position: absolute; bottom: 30px; z-index: 500;"
          class="elevation-16"
        >
          Add {{ selectedProperties.length }} Selected Properties
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SelectPropertiesMapDialog",
  components: {
  },
  data: () => ({
    dialog: false,
    properties: [],
    addresses: [],
    boundsMarkers: [],

    selectedProperties: [],

    polygon: null,
    mapOptions: {
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      mapTypeControl: false,
      zoomControl: false,
      styles: [{
        featureType: 'poi',
        stylers: [{visibility: 'off'}],
      }],
      disableDefaultUI: true,
      gestureHandling: 'greedy'
    },
    markerOptions: {
      url: process.env.VUE_APP_BACKEND_BASE + 'img/rpd-marker-w.png',
      scaledSize: {
          width: 24,
          height: 30
      }
    },
    mapCenter: {lat: 51.509865, lng: -0.118092},
    mapZoom: 7,
    mapType: 'hybrid',
    drawingManager: null,
    map: null,
    rectangleBounds: {
      north: 51.514865,
      south: 51.504865,
      east: -0.113092,
      west: -0.123092,
    },

    dragDelay: false,
  }),
  methods: {
    async showDialog(tenantId) {
      this.dialog = true;
      //get all properties with tenant filter
      await this.getProperties(tenantId);
      this.$gmapApiPromiseLazy().then(() => {
        let _self = this;
        // this.$refs.map.$mapObject
        // this.initRectangle();
      });
      // this.properties = properties;
      this.addresses = this.properties.map((item) => {
        item.icon = item.address.data.logo ? {
          url: (process.env.VUE_APP_BACKEND_BASE + item.address.data.logo),
          labelOrigin: {x: 10, y: 40}
        } : {url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png', labelOrigin: {x: 10, y: 40}};
        // item.label = {color: 'white', fontWeight: 'bold', fontSize: '14px', text: item.unit, className: "labels"};
        item.lat = parseFloat(item.address.data.lat);
        item.lng = parseFloat(item.address.data.lng);
        return item;
      });
    },
    closeDialog: function () {
      this.dialog = false;
      this.properties = [];
      this.$emit('closed');
    },
    selectMarkersWithinBounds(bounds) {
      // use google.maps.geometry.poly.containsLocation(latLng, polygon) to check if a marker is within the polygon
      this.selectedProperties = this.addresses.filter(address => google.maps.geometry.poly.containsLocation(new google.maps.LatLng(address.lat, address.lng), this.polygon));
    },

    submitSelection() {
      this.$emit('submitted', this.selectedProperties);
      this.closeDialog();
    },

    onBoundsChanged() {
      const rectangle = this.$refs.rectangle.$mapObject;
      const ne = rectangle.getBounds().getNorthEast();
      const sw = rectangle.getBounds().getSouthWest();
    },

    async getProperties(tenantId) {
      const response = await this.$http.get('/properties', {
        params: {
          include: 'address,scheme',
          tenant_id: tenantId,
          per_page: 3000,
        }
      });
      this.properties = response.data.data
    },

    onMapClick(e) {
      // create new marker at the clicked position in their own array

      let marker = new google.maps.Marker({
        position: e.latLng,
        map: this.$refs.map.$mapObject,
        draggable: true,
        icon: {
          url: process.env.VUE_APP_BACKEND_BASE + 'img/rpd-marker-p.png',
          scaledSize: {
            width: 24,
            height: 30
          }
        }
      })

      this.boundsMarkers.push(marker);

      marker.addListener('dragend', () => {
        this.drawPolygon();
      });      

      // draw polygon while dragging
      marker.addListener('drag', () => {
        if (!this.dragDelay) {
          this.dragDelay = true;
          setTimeout(() => {
            this.dragDelay = false;
            this.drawPolygon(); 
          }, 5);
        }
      });
      
      // on marker right click remove it
      marker.addListener('rightclick', () => {
        marker.setMap(null);
        this.boundsMarkers = this.boundsMarkers.filter(m => m !== marker);
        this.drawPolygon();
      });
      

      this.drawPolygon();
    },

    drawPolygon() {
      // create a new polygon from the markers
      if (this.polygon) {
        this.polygon.setMap(null);
      }
      this.polygon = new google.maps.Polygon({
        paths: this.boundsMarkers.map(marker => marker.getPosition()),
        map: this.$refs.map.$mapObject,
        editable: false,
        draggable: false,
        fillColor: '#807cba',
        fillOpacity: 0.25,
        strokeColor: '#000000',
        strokeOpacity: 1,
      });
      
      google.maps.event.addListener(this.polygon.getPath(), 'set_at', () => {
        this.boundsMarkers = polygon.getPath().getArray().map(latLng => new google.maps.Marker({ position: latLng }));
      });
      google.maps.event.addListener(this.polygon.getPath(), 'insert_at', () => {
        this.boundsMarkers = polygon.getPath().getArray().map(latLng => new google.maps.Marker({ position: latLng }));
      });

      // update the markers when the polygon is edited or dragged
      google.maps.event.addListener(this.polygon, 'dragend', () => {
        this.boundsMarkers = this.polygon.getPath().getArray().map(latLng => new google.maps.Marker({ position: latLng }));
      });
      google.maps.event.addListener(this.polygon, 'bounds_changed', () => {
        this.boundsMarkers = this.polygon.getPath().getArray().map(latLng => new google.maps.Marker({ position: latLng }));
      });

      // select markers within the polygon using the marker positions
      
      let paths = this.polygon.getPaths();
      let bounds = new google.maps.LatLngBounds();

      paths.forEach(path => {
        path.forEach(latLng => {
          bounds.extend(latLng);
        });
      });
      

      this.selectMarkersWithinBounds(bounds);
    },

    // initRectangle() {
    //   const bounds = {
    //     north: 51.514865,
    //     south: 51.504865,
    //     east: -0.113092,
    //     west: -0.123092,
    //   };

    //   // Define the rectangle and set its editable property to true.
    //   const rectangle = new google.maps.Rectangle({
    //     bounds: bounds,
    //     editable: true,
    //     draggable: true,
    //   });

    //   rectangle.setMap(this.$refs.map.$mapObject);
    // },
  },

}
</script>

<style scoped>

</style>
